import styled from "styled-components";
import Form from "../Components/Form";

export default function Contact(){
    return(
        <Content>
            <img src="/img/spcrio-novo.png" alt="Logo SPC Rio" />
            <p>Estamos aqui para ajudar! Preencha o formulário abaixo e nossa equipe entrará em contato o mais breve possível.</p>
            <p>Se você deseja saber mais sobre nossos serviços, ter suporte especializado ou tirar dúvidas sobre nossos serviços, envie sua mensagem — teremos prazer em atender você.</p>
            <p>Nos empenhamos em oferecer um atendimento ágil e de qualidade, garantindo que sua experiência conosco seja sempre completa e satisfatória.</p>
            <Form/>
        </Content>
    )
}

const Content = styled.main`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    p{
        width: 60%;
        font-size: 20px;
        font-family: 'poppins', sans-serif;
        font-weight: bolder;
        color:#264b91;
    }

    img{
        height: 160px;
        margin-top: 40px;
    }
`